import useDineIn from "./useDineIn";
import useQueryParam from "./useQueryParam";
import useSuccesOrder from "./useSuccesOrder";

export { useDineIn, useQueryParam, useSuccesOrder };